<template>
	<v-container grid-list-xs class="pb-3">

		<v-layout row wrap>
			<v-textarea
				clearable
				auto-grow
				hide-details
				outline
				:rows="3"
				placeholder="Saisissez ici une ou plusieurs références Suifa"
				v-model="search"
				ref="search-area"
				:loading="loading"
				@keyup.enter="onSearchEnter()"
				@change="onSearchChange()">
			</v-textarea>
		</v-layout>

		<div class="mt-3" v-if="materials.length">
			{{ materials.length }}
			<span v-if="materials.length > 1">
				assets trouvés
			</span>
			<span v-else>
				asset trouvé
			</span>
			<div id="table-container">
				<table class="materials-table">
					<tbody>
						<tr v-for="(material, i) in materials" :key="'material' + i">
							<td class="text-right">
								<v-chip label small color="error" v-if="material.invalid">
									{{ material.status }}
								</v-chip>
								<v-chip label small color="success" v-else>
									{{ material.status }}
								</v-chip>
							</td>
							<td v-if="multiselect && !no_select">
								<v-checkbox
									multiple
									hide-details
									:disabled="material.invalid"
									v-model="selected_multi"
									:value="material.path"
									class="ma-0 pa-0">
								</v-checkbox>
							</td>
							<td v-if="!multiselect && !no_select">
								<v-radio-group
									v-model="selected"
									class="ma-0 pa-0"
									hide-details>
									<v-radio
										:disabled="material.invalid"
										:value="material.path"
										class="ma-0 pa-0">
									</v-radio>
								</v-radio-group>
							</td>
							<td>
								<div>{{ material.ref }}</div>
								<div class="caption">{{ material.path }}</div>
							</td>
							<td>
								<v-btn
									flat icon
									class="ma-0"
									:disabled="material.invalid"
									@click="probeFile(material.path)"
									title="probe">
									<v-icon>help</v-icon>
								</v-btn>
							</td>
							<td>
								<v-btn
									flat icon
									class="ma-0"
									:disabled="material.invalid"
									@click="copyPath(material.path)"
									title="copier">
									<v-icon>content_copy</v-icon>
								</v-btn>
							</td>
							<td>
								<v-btn
									flat icon
									class="ma-0"
									:disabled="material.invalid || !fileopener_status"
									@click="openFile(material.path)"
									title="ouvrir">
									<v-icon>folder</v-icon>
								</v-btn>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<v-layout row v-if="!no_select && materials.length">
			<v-spacer></v-spacer>
			<div v-if="multiselect">
				<v-btn
					:disabled="selected_multi.length === 0"
					color="primary color--text"
					class="text-none mt-2"
					@click="emitSelected(selected_multi)">
					{{ selected_multi.length }} Asset(s) Sélectionné(s)
					<v-icon large right>arrow_forward</v-icon>
				</v-btn>
			</div>
			<div v-else>
				<v-btn
					:disabled="!selected"
					color="primary color--text"
					class="text-none mt-2"
					@click="emitSelected([selected])">
					{{ selected.path }}
					<v-icon large right>arrow_forward</v-icon>
				</v-btn>
			</div>
		</v-layout>

		<v-dialog
			v-model="modal_probe.visible"
			scrollable
			max-width="800px"
			transition="dialog-transition">
			<v-card class="background">
				<v-card-title
					class="py-1 px-3 primary color--text subheading word-break-all">
					{{ modal_probe.title }}
					<v-spacer></v-spacer>
					<v-btn
						flat icon
						color="color"
						class="my-0"
						@click="openFile('show', modal_probe.title)">
						<v-icon>folder</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text class="pa-0" v-if="modal_probe.visible">
					<v-progress-linear
						v-if="modal_probe.loading"
						color="primary"
						indeterminate>
					</v-progress-linear>
					<ProbeDisplay
						v-if="!modal_probe.loading && !modal_probe.error"
						:probe="modal_probe.data">
					</ProbeDisplay>
					<v-alert
						type="error"
						class="pa-2 ma-0"
						:value="modal_probe.error !== ''">
						{{ modal_probe.error }}
					</v-alert>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-snackbar
			bottom
			:timeout="1500"
			color="success"
			v-model="snackbar_show">
			Chemin copié
		</v-snackbar>

	</v-container>
</template>

<script>
import ProbeDisplay from '@/components/ffprobe_display_nexus.vue'
const Path = require('path')
export default {
	props: [
		'multiselect',
		'no_select'
	],
	components: { ProbeDisplay },
	data () {
		return {
			search: null,
			materials: [],
			snackbar_show: false,
			selected: '',
			selected_multi: [],
			loading: false,
			modal_probe: {
				title: '',
				error: '',
				data: {},
				visible: false,
				loading: false
			}
		}
	},
	computed: {
		fileopener_status () {
			return this.$store.getters.fileopener_status
		}
	},
	methods: {
		onSearchEnter () {
			this.$refs['search-area'].blur()
		},
		async onSearchChange () {
			if (this.loading) return
			this.selected = ''
			this.selected_multi = []
			var re = /[0-9]{2}(_|-|\/|\\)[0-9]{2}(_|-|\/|\\)[A-Z, a-z, 0-9]{4}/g
			var found = this.search.match(re)
			if (!found) return
			this.loading = true
			this.materials = found.map(ref => {
				return {
					ref: ref.replace(/(_|-|\/|\\)/g, '/'),
					path: null,
					status: null,
					invalid: true
				}
			})
			this.search = null
			for (let material of this.materials) {
				try {
					let response = await this.$ApiNexus.mamAssetFinder(material.ref)
					if (response.data.error) {
						material.status = response.data.error
					} else {
						let path = '//'
						path += response.data.device_name
						path += '/TRAVAUX/'
						path += response.data.path.replace(/\\/g, '/')
						material.status = response.data.last_scan_status
						material.path = path
						let validStatus = ['Existing', 'New']
						if (validStatus.indexOf(response.data.last_scan_status) > -1) {
							material.invalid = false
						}
					}
				} catch (error) {
					console.log(error)
				}
			}
			this.loading = false
		},
		probeFile (filepath) {
			this.modal_probe.title = filepath
			this.modal_probe.error = ''
			this.modal_probe.data = {}
			this.modal_probe.visible = true
			this.modal_probe.loading = true
			this.$ApiNexus.ffprobe(this.$paths.UNCToMaestro(filepath))
				.then(result => {
					this.modal_probe.loading = false
					this.modal_probe.data = result.data.detail
				})
				.catch(error => {
					console.error('probeFile error', error.response)
					this.modal_probe.loading = false
					this.modal_probe.error = error.response.data
				})
		},
		openFile (path) {
			this.$FileOpener.fileOpener('open', path)
				.catch(error => {
					console.log('openWorkingDir error', error)
				})
		},
		copyPath (path) {
			if (navigator.platform.indexOf('Win') > -1) {
				path = path.replace(/\//g, '\\')
			} else {
				path = this.$paths.UNCToMaestro(path)
			}
			this.$clipboard(path)
			this.snackbar_show = true
		},
		emitSelected (pathList) {
			let assets = pathList.map(filepath => {
				return {
					path: filepath,
					name: Path.basename(filepath)
				}
			})
			if (this.multiselect) {
				this.$emit('asset-selected', assets)
			} else {
				this.$emit('asset-selected', assets[0])
			}
		}
	}
}
</script>

<style lang="stylus" scoped>
>>>textarea
	margin-top: 0 !important

#table-container
	max-height: 57vh
	overflow-y: scroll
	border: 1px solid var(--v-background-lighten1)

.materials-table
	width: 100%
	td
		padding: 0 10px
	tr:nth-child(odd)
		background-color: rgba(255, 255, 255, 0.05)
	tr:nth-child(even)
		background-color: rgba(0, 0, 0, 0.05)
</style>



// WEBPACK FOOTER //
// src/pages/filesystem/asset_finder.vue